module.exports = __webpack_public_path__ + "img/ai-chat-send-icon.45e8a8b3.svg";